import { Tooltip } from "@heroui/react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

interface WhatsAppButtonProps {
  phoneNumber: string;
  contactId?: number;
  companyId?: number;
  contactName?: string;
  size?: number;
}

/**
 * WhatsApp button that opens YallyHub conversations
 */
export const DevWhatsAppButton = ({
  phoneNumber,
  contactId,
  companyId,
  contactName,
  size = 14,
}: WhatsAppButtonProps) => {
  // Build WhatsApp conversation URL with contact info
  const buildWhatsAppUrl = (phone: string) => {
    const params = new URLSearchParams({
      phone: phone,
      ...(contactId && { contactId: contactId.toString() }),
      ...(companyId && { companyId: companyId.toString() }),
      ...(contactName && { name: contactName }),
    });
    return `/conversations?${params.toString()}`;
  };

  return (
    <Tooltip content={`WhatsApp naar ${phoneNumber}`}>
      <Link
        to={buildWhatsAppUrl(phoneNumber)}
        target="_blank"
        rel="noopener noreferrer"
        className="p-0.5 rounded hover:bg-[#25D366]/10 text-[#25D366] hover:text-[#128C7E]"
        onClick={(e) => e.stopPropagation()}
      >
        <WhatsappLogo weight="duotone" size={size} />
      </Link>
    </Tooltip>
  );
};

export default DevWhatsAppButton;
